import { Select } from "shared/components";
import { type Register } from "shared/hooks";
import { AmenitiesSelect } from "./components/AmenitiesSelect";
import { SectionCard } from "shared/app/SectionCard";

const petOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" }
];

interface AmenitiesFormProps {
  headerExtra?: React.ReactNode;
  register: Register;
  selectedAmenities: number[];
  isUnit?: boolean;
  footer?: React.ReactNode;
  level?: "property" | "unit";
  onPetPolicyChange?: (field: "cats_allowed" | "dogs_allowed") => void;
}

export const AmenitiesForm = (props: AmenitiesFormProps) => {
  const {
    register,
    selectedAmenities,
    level = "property",
    headerExtra,
    footer,
    onPetPolicyChange
  } = props;

  const handleSelect = (value: number[]) => {
    register("amenities").onChange(value);
  };

  const wrapPetPolicy = (field: "cats_allowed" | "dogs_allowed") => {
    const base = register(field);
    return {
      ...base,
      onChange: (val: unknown) => {
        onPetPolicyChange?.(field);
        base.onChange(val);
      }
    };
  };

  return (
    <SectionCard title="Amenities" headerExtra={headerExtra} footer={footer}>
      <div className="space-y-4">
        <div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Select
                id="cat-allowed"
                label="Cat allowed"
                options={petOptions}
                required
                {...wrapPetPolicy("cats_allowed")}
              />
            </div>
            <div>
              <Select
                id="dog-allowed"
                label="Dog allowed"
                options={petOptions}
                required
                {...wrapPetPolicy("dogs_allowed")}
              />
            </div>
          </div>
        </div>

        <AmenitiesSelect
          level={level}
          onSelect={handleSelect}
          selectedAmenities={selectedAmenities}
        />
      </div>
    </SectionCard>
  );
};
